import { ObjectSchema } from '@tableau/auto-form';

import { Messages } from '~src/codegen/Localize';
import { ISiteSettingsMetadataBySections } from '~src/settings/site-settings/restApi/types/ISiteSettingsMetadata';

const typeMap: { [serverSideType: string]: string } = {
    'Boolean': 'boolean',
    'Integer': 'number'
};

const formatMap: { [serverSideFormat: string]: string } = {
    'radioButton': 'radiobutton',
    'default': 'default'
};

function convertVisibleWhen(dependsOn: string): string | undefined {
    return dependsOn ? `$form.${dependsOn}` : undefined;
}

function getLocalizedString(messageKey: string): string {
    const messageFunction = Messages[messageKey as keyof typeof Messages] as any;
    if (typeof messageFunction === 'function') {
        return messageFunction();
    }
    return messageKey;
}

export function convertSiteSettingMetadataToAutoFormSchema(apiResponse: ISiteSettingsMetadataBySections): ObjectSchema[] {
    const sectionProperties: ObjectSchema[] = [];
    for (const section of apiResponse.sectionMetadata) {
        sectionProperties.push({
            type: 'object',
            properties: section.siteSettingMetadata.map(setting => {
                let localizedOptions = setting.options;
                if (setting.options?.list) {
                    localizedOptions = {
                        ...setting.options,
                        list: setting.options.list.map(option => ({
                            ...option,
                            text: option.text ? getLocalizedString(option.text) : option.text
                        }))
                    };
                }
                return {
                    name: setting.name,
                    type: typeMap[setting.type],
                    displayName: setting.displayName ? getLocalizedString(setting.displayName) : undefined,
                    description: setting.displayDescription ? getLocalizedString(setting.displayDescription) : undefined,
                    format: formatMap[setting.format],
                    defaultValue: setting.defaultValue,
                    visibleWhen: setting.dependsOn ? convertVisibleWhen(setting.dependsOn) : null,
                    options: localizedOptions,
                };
            })
        });
    }
    return sectionProperties;
}
